module.exports = __webpack_public_path__ + "static/media/new_logo.a20ac41c.png";